import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';
import { getImageUrl } from '../utils/cdn';
import './Cart.css';

const Cart = () => {
  const { cartItems, cartTotal, updateCartItem, removeFromCart, fetchCart } = useCart();
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      fetchCart();
    }
  }, [user]);

  const handleQuantityChange = async (itemId, newQuantity) => {
    if (newQuantity < 1) return;
    await updateCartItem(itemId, newQuantity);
  };

  const handleRemove = async (itemId) => {
    if (window.confirm('Remove this item from cart?')) {
      await removeFromCart(itemId);
    }
  };

  if (!cartItems || cartItems.length === 0) {
    return (
      <>
        <Helmet>
          <title>Cart - NieHairLabel</title>
        </Helmet>
        <div className="cart-page">
          <div className="container">
            <h1>Shopping Cart</h1>
            <div className="empty-cart">
              <p>Your cart is empty</p>
              <Link to="/shop" className="btn btn-primary">Continue Shopping</Link>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>Cart - NieHairLabel</title>
      </Helmet>
      <div className="cart-page">
        <div className="container">
          <h1>Shopping Cart</h1>
          <div className="cart-content">
            <div className="cart-items">
              {cartItems && cartItems.map(item => (
                <div key={item.id} className="cart-item">
                  <div className="item-image">
                    {item.image_url ? (
                      <img
                        src={getImageUrl(item.image_url)}
                        alt={item.name}
                      />
                    ) : (
                      <div className="placeholder">No Image</div>
                    )}
                  </div>
                  <div className="item-details">
                    <h3>{item.name || 'Product'}</h3>
                    <p className="item-price">${parseFloat(item.price || 0).toFixed(2)}</p>
                    {item.is_sold_out && (
                      <p className="sold-out-text">This item is sold out</p>
                    )}
                  </div>
                  <div className="item-quantity">
                    <button onClick={() => handleQuantityChange(item.id, item.quantity - 1)}>-</button>
                    <input
                      type="number"
                      min="1"
                      value={item.quantity}
                      onChange={(e) => handleQuantityChange(item.id, parseInt(e.target.value) || 1)}
                    />
                    <button onClick={() => handleQuantityChange(item.id, item.quantity + 1)}>+</button>
                  </div>
                  <div className="item-subtotal">
                    <p>${(parseFloat(item.price || 0) * item.quantity).toFixed(2)}</p>
                  </div>
                  <button
                    className="remove-btn"
                    onClick={() => handleRemove(item.id)}
                    aria-label="Remove item"
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>

            <div className="cart-summary">
              <h2>Order Summary</h2>
              <div className="summary-row">
                <span>Subtotal</span>
                <span>${parseFloat(cartTotal || 0).toFixed(2)}</span>
              </div>
              <div className="summary-row">
                <span>Shipping</span>
                <span>Calculated at checkout</span>
              </div>
              <div className="summary-row total">
                <span>Total</span>
                <span>${parseFloat(cartTotal || 0).toFixed(2)}</span>
              </div>
              <Link to="/checkout" className="btn btn-primary btn-large">
                Proceed to Checkout
              </Link>
              <Link to="/shop" className="btn btn-outline btn-large">
                Continue Shopping
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Cart;

